
import { computed, defineComponent, PropType } from 'vue'
import { FreeSubscriptionSearchFilter } from '@/views/_shared/search-list/types'
import FreeSubscriptionsFormFieldSubscriptionType from '@/components/free-subscriptions/form-fields/filtering/subscription-type.vue'
import FreeSubscriptionsFormFieldProcessType from '@/components/free-subscriptions/form-fields/filtering/process-type.vue'
import FreeSubscriptionsFormFieldCreatedBy from '@/components/free-subscriptions/form-fields/filtering/created-by.vue'
import FreeSubscriptionsFormFieldId from '@/components/free-subscriptions/form-fields/filtering/id.vue'
import FreeSubscriptionsFormFieldUser from '@/components/free-subscriptions/form-fields/filtering/user.vue'
import FreeSubscriptionsFormFieldStartDate from '@/components/free-subscriptions/form-fields/filtering/start-date.vue'
import FreeSubscriptionsFormFieldEndDate from '@/components/free-subscriptions/form-fields/filtering/end-date.vue'

export default defineComponent({
    name: 'free-subscriptions-filter',
    components: {
        FreeSubscriptionsFormFieldSubscriptionType,
        FreeSubscriptionsFormFieldProcessType,
        FreeSubscriptionsFormFieldCreatedBy,
        FreeSubscriptionsFormFieldId,
        FreeSubscriptionsFormFieldUser,
        FreeSubscriptionsFormFieldStartDate,
        FreeSubscriptionsFormFieldEndDate
    },
    props: {
        modelValue: {
            type: Object as PropType<FreeSubscriptionSearchFilter>
        }
    },
    setup (props, { emit }) {
        const localModel = computed({
            get: () => props.modelValue,
            set: value => emit('update:modelValue', value)
        })

        return {
            localModel
        }
    }
})
